module.exports = __webpack_public_path__ + "img/wifi.9a90df82.png";